
import { Component } from "vue-property-decorator";
import { ProjectView } from "@/views/project-view";

@Component
export default class extends ProjectView {
    /// define
    quick = this.quicks().Membership;
}
